import { createSlice } from '@reduxjs/toolkit';

import { CONNECTION_QUALITY, CONNECTION_STATUS } from '../constants';

// Deliberately has no RESET_ALL_REDUCERS case: the connection outlives any session teardown, and the
// flags belong to screens that are still mounted. Only one camera layer or loading screen is ever on
// screen at a time, so each is a plain flag.
const initialState = {
    status: CONNECTION_STATUS.ONLINE,
    quality: CONNECTION_QUALITY.GOOD,
    // Full-screen camera layers that cover the header; the banner moves to the top edge over them.
    fullscreenLayer: false,
    // Loading screens showing their own slow-connection hint; the slow banner stays hidden over them.
    analysisScreen: false,
};

const connectivitySlice = createSlice({
    name: 'connectivity',
    initialState,
    reducers: {
        connectionStatusChanged: (state, action) => {
            state.status = action.payload;
        },
        connectionQualityChanged: (state, action) => {
            state.quality = action.payload;
        },
        fullscreenLayerShown: (state) => {
            state.fullscreenLayer = true;
        },
        fullscreenLayerHidden: (state) => {
            state.fullscreenLayer = false;
        },
        analysisScreenShown: (state) => {
            state.analysisScreen = true;
        },
        analysisScreenHidden: (state) => {
            state.analysisScreen = false;
        },
    },
});

export const {
    connectionStatusChanged,
    connectionQualityChanged,
    fullscreenLayerShown,
    fullscreenLayerHidden,
    analysisScreenShown,
    analysisScreenHidden,
} = connectivitySlice.actions;
export default connectivitySlice.reducer;
